import React from 'react';
import './posts.scss';

const ProgrammeRep1 = () => {
  return (
    <div className="evaluation-container">
      <h1>Joined Students Association as a Programme Representative</h1>
      <h3>Category: Student Activity</h3>
      <p className="date">Written on Tuesday, 8 Oct 2024, in JCMB.</p>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/Programme%20Representative%20Welcome.jpg?alt=media&token=6191bb01-5671-4278-ab4a-29dec92a3d61"
        alt="welcome-email"
        className="cafe-image"
      />
      <p>
        I've become a 2024/25 Year 3 Mathematical Physics Programme Representative! Being a rep and supporting the school has been
        one of my biggest goals in college, so I'm very grateful for this opportunity. <br/><br/><br/>

        My role is to represent fellow students in the third-year Mathematical Physics Programme.
        I'll be working closely with other student representatives and leaders, including members of academic societies,
        to ensure that any issues affecting students beyond our programme are effectively escalated and addressed.<br/><br/><br/>

        The School of Physics and Astronomy has an upcoming SSLC (Student Staff Liaison Committee) meeting, so my fellow Year 3
        physics reps and I are sending out online surveys to gather feedback on students' academic and social experiences this semester.
      </p>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/Survey.png?alt=media&token=2de290bc-551b-44ce-94e9-7441b5a128c3"
        alt="welcome-email"
        className="cafe-image"
      />

      <p>
        I also made an announcement at the beginning of the workshops to encourage students to complete the survey.
      </p>

      <p>
        Since we’ve just set everything up and the timeframe is tight, we’re working at a fast pace. There have been some ongoing issues and challenges with the process,
        so we'll be meeting tomorrow to address these issues, review the survey results, and plan our next steps.
      </p>

      <p>
        While working as a rep, I’ve found that my past work experiences have been very helpful. Although this role isn’t a scientific or technological one,
        it requires a lot of communication, teamwork, and decision-making skills.
      </p>

      <p>
        Lastly, I’d like to end this post with something my friend told me when I told her I became a rep:
      </p>

      <p><em><strong>
        With great power comes great responsibility!
      </strong></em></p>

    </div>
  );
};

export default ProgrammeRep1;